import { Icon } from 'leaflet';
import { getObjectIcon, IconColor } from '../icons';
import { RotationModel } from '../utils';
import { PropsWithChildren, ReactElement, useMemo } from 'react';
import RotatableMarker from '../rotatable-marker/RotatableMarker';

export interface AssetPositionMarkerProps extends RotationModel {
  color: IconColor;
}

export function AssetPositionMarker({
  position,
  heading,
  color,
  children,
}: PropsWithChildren<AssetPositionMarkerProps>): ReactElement {
  const icon = useMemo<Icon>(() => {
    return getObjectIcon(color, heading);
  }, [color, heading]);

  return (
    <RotatableMarker icon={icon} position={position} heading={heading}>
      {children}
    </RotatableMarker>
  );
}

export default AssetPositionMarker;
